/**
 * @generated SignedSource<<f2ffc787d56cb7e13eefb7370d8a49ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SignUpInput = {
  clientMutationId?: string | null | undefined;
  email: string;
  name: string;
  password: string;
};
export type SessionProviderSignUpMutation$variables = {
  input: SignUpInput;
};
export type SessionProviderSignUpMutation$data = {
  readonly signUp: {
    readonly error: string | null | undefined;
    readonly user: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type SessionProviderSignUpMutation = {
  response: SessionProviderSignUpMutation$data;
  variables: SessionProviderSignUpMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SignUpPayload",
    "kind": "LinkedField",
    "name": "signUp",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SessionProviderSignUpMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SessionProviderSignUpMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d27ad881602d92d7f606e01749a9c27b",
    "id": null,
    "metadata": {},
    "name": "SessionProviderSignUpMutation",
    "operationKind": "mutation",
    "text": "mutation SessionProviderSignUpMutation(\n  $input: SignUpInput!\n) {\n  signUp(input: $input) {\n    error\n    user {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "41105f40bc80dcf53808018ad7b4e3e1";

export default node;
